__turbopack_context__.v({
  "helios-select-field": "Lk_oqW_helios-select-field",
  "helios-select-field__chevron": "Lk_oqW_helios-select-field__chevron",
  "helios-select-field__select": "Lk_oqW_helios-select-field__select",
});
